exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-social-widget[data-v-e56ae738]{\n\tpadding: 0.8em 1em;\n}\n", ""]);

// exports
